// extracted by mini-css-extract-plugin
module.exports = {"section":"FixProcessEu_section__Vy_3g"};